import React from 'react';

const useDebounce = (callback, delay) => {
    const timeoutRef = React.useRef(null);

    return (...args) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            callback(...args);
        }, delay);
    };
};

export default useDebounce;
